var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const addRemoveInBookmark = (id, status, element) => {
    console.log('$id', id, status);
    const url = var_from_php.ajax_url;
    const formData = new FormData();
    const statusNumber = status ? '1' : '0';
    console.log('status', statusNumber);
    formData.append('action', 'trigger_bookmark');
    formData.append('id', id);
    formData.append('status', statusNumber);
    const options = {
        method: 'POST',
        body: formData,
    };
    fetch(url, options)
        .then(function (response) {
        return response.json();
    })
        .then(function (response) {
        console.log('responce', response);
        if (response.data.trigger === 'add') {
            element.classList.add('active');
        }
        if (response.data.trigger === 'remove') {
            element.classList.remove('active');
        }
    })
        .catch(function (error) {
        console.error('Ошибка AJAX-запроса:', error);
    });
};
export const removeBookmarkInShop = () => {
    const buttons = document.querySelectorAll('.js-remove-book-in-shop');
    buttons && buttons.forEach((button) => {
        console.log('2');
        button.addEventListener('click', (event) => __awaiter(void 0, void 0, void 0, function* () {
            console.log('1');
            const { target } = event;
            const formData = new FormData();
            if (target instanceof HTMLElement) {
                const id = target.getAttribute('data-id');
                formData.append('action', 'remove_from_bookshop');
                formData.append('id', id);
                const response = yield fetch(var_from_php.ajax_url, {
                    method: 'POST',
                    body: formData,
                });
                const respJson = yield response.json();
                console.log('respJson', respJson);
                if (respJson.data.message.action === 'removed') {
                    target.classList.add('removed');
                }
                else {
                    target.classList.remove('removed');
                }
            }
        }));
    });
};
const checkCookie = () => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append('action', 'check_session_variable');
    const response = yield fetch(var_from_php.ajax_url, {
        method: 'POST',
        body: formData,
    });
    const respJson = yield response.json();
    return respJson.success;
});
export const initActionsBookmarks = (popupInstanse) => {
    const bookmarkBtns = document.querySelectorAll('.js-add-to-bookmark');
    const loginAndBookmarkBtn = document.querySelector('.js-login-and-add-to-bookmark');
    bookmarkBtns &&
        bookmarkBtns.forEach((item) => {
            item.addEventListener('click', (event) => __awaiter(void 0, void 0, void 0, function* () {
                const { target } = event;
                const authTokenCheck = yield checkCookie();
                if (!authTokenCheck) {
                    popupInstanse.openOnePopup('#auth-popup');
                }
                else {
                    if (target instanceof HTMLElement) {
                        const id = target.getAttribute('data-id');
                        const active = target.classList.contains('active');
                        addRemoveInBookmark(id, active, target);
                        if (!active) {
                            target.classList.add('active');
                        }
                        else {
                            target.classList.remove('active');
                        }
                    }
                }
            }));
        });
    loginAndBookmarkBtn &&
        loginAndBookmarkBtn.addEventListener('click', (event) => __awaiter(void 0, void 0, void 0, function* () {
            const target = event.target;
            event.preventDefault();
            const authTokenCheck = yield checkCookie();
            if (!authTokenCheck) {
                popupInstanse.openOnePopup('#auth-popup');
            }
            else {
                window.location.href = target.href;
            }
        }));
};
